/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderItemModifierCreateSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	size: z.uuid().nullish(),
	marking_code: z.string().nullish(),
});
